import { render, staticRenderFns } from "./EInsurance.vue?vue&type=template&id=55433c44&"
import script from "./EInsurance.vue?vue&type=script&lang=js&"
export * from "./EInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports